import { useEffect, useState, useRef } from "react";
import { IBindingWx } from "../types";
import request from "project-config/services/request/request";
import QRCode from "../../../../../../service/qr-code";
import { useGlobalStore } from "@/store/GlobalStore";
import { BindOperate } from "@/pages/profile/constant/mini-program";

export function useBindMini(trigger: boolean) {
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [currentBindingWx, setCurrentBindingWx] = useState<IBindingWx | null>();
  const [isCurrentBindingWx, setIsCurrentBindingWx] = useState(false);
  const [loadingQRCode, setLoadingQRCode] = useState(true);
  const { userInfo } = useGlobalStore();
  const timer = useRef<NodeJS.Timer>();

  const getCurrentBindingWx = async () => {
    const res = await request.post("/api/rendering/user/wxbind/queryBindingWx");
    if (res && res.result && res.data) {
      setCurrentBindingWx(res.data);
      setIsCurrentBindingWx(true);
    } else {
      setCurrentBindingWx(null);
      setIsCurrentBindingWx(false);
    }
  };

  const handleBind = async (bind: boolean) => {
    const res = await request.post("/api/rendering/user/wxbind/bindWxToUser", {
      bindType: bind ? BindOperate.Bind : BindOperate.Cancel,
      id: currentBindingWx?.id,
    });
    if (res && res.code === 200) {
      getCurrentBindingWx();
    }
  };

  useEffect(() => {
    if (trigger) {
      getCurrentBindingWx();
      const qrCodeUrl = QRCode.getQRCodeByKey(
        userInfo?.userId!,
        "inviteQRCodeUrl"
      );
      if (qrCodeUrl) {
        setQrCodeUrl(qrCodeUrl);
        setLoadingQRCode(false);
      } else {
        request.post("/api/rendering/user/wxbind/inviteQRcode").then((res) => {
          if (res.code === 200) {
            setQrCodeUrl(res.data);
            setLoadingQRCode(false);
            QRCode.setQRCode(userInfo?.userId!, "inviteQRCodeUrl", res.data);
          }
        });
      }
      timer.current = setInterval(() => {
        getCurrentBindingWx();
      }, 5000);
    } else {
      window.clearInterval(timer.current);
      setLoadingQRCode(true);
    }
  }, [trigger, userInfo]);
  return {
    isCurrentBindingWx,
    currentBindingWx,
    getCurrentBindingWx,
    loadingQRCode,
    qrCodeUrl,
    handleBind,
  };
}
